import { CREATE_NEW_FOLDER } from '../../../../Constants';

export function createNewFolderAction(payload){
    return{
        type:CREATE_NEW_FOLDER,
        payload
    }
}